import { isMobile } from '../../scripts/helpers';

export default class BoxCards {
  constructor() {

    var boxListCarouselSM = document.querySelector('.featured--carousel .box-cards__list--sm-carousel');

    if(typeof(boxListCarouselSM) != 'undefined' && boxListCarouselSM != null) {
      if(!isMobile()) {
        $('.featured--carousel .box-cards__list--sm-carousel').slick({
          centerMode: false,
          slidesToShow: 3,
          dots: false,
          arrows: true,
          slidesToScroll: 3,
          infinite: false,
          responsive: [
            {
              breakpoint: 1099,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false
              }
            }
          ]
        });
      }
    }
    
    var boxListCarouselFull = document.querySelector('.featured--carousel-full .box-cards__list--sm-carousel');

    if(typeof(boxListCarouselFull) != 'undefined' && boxListCarouselFull != null) {
      if(!isMobile()) {
        $('.featured--carousel-full .box-cards__list--sm-carousel').slick({
          centerMode: false,
          slidesToShow: 8,
          dots: false,
          arrows: true,
          slidesToScroll: 8,
          infinite: false
        });
      }
    }

  }
}

const boxCards = new BoxCards();